import React, { useContext, useEffect, useState } from "react";
import { ExamContext, userContext } from "../../App";
import axios from "axios";
import Loading from "../../Shared/Loading";
import { toast } from "react-toastify";
import { ProgressBar } from "react-loader-spinner";
import { calculateGreat, totalMarks, totalMaxMarks } from "../../Utils/CalculateFunction";
import { classFiveSub, jscSub, primarySub, secondarySub, sscSub } from "../../data/subjectData";

const BulkSms = () => {
  const [users, userLoading] = useContext(userContext);
  const [xms] = useContext(ExamContext);
  const MyXm = xms?.find((i) => i?.examName === "2nd Semester Exam");
  const [send, setSend] = useState("");
  const [smsType, setSmsType] = useState("Single");
  const [smsBalance, setSmsBalance] = useState();
  const [searchTerm, setSearchTerm] = useState("");
  const [message, setMessage] = useState(
    "প্রিয় অভিভাবক, আগামীকাল স্কুল বন্ধ থাকবে। নবজাগরণ একাডেমি https://www.nabojagoron-academy.com/"
  );
  const [dataUser, setData] = useState(users);
  const [Class, setClass] = useState();
  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);

  const [xmSub, setXmSub] = useState([...sscSub]);

  // Subject select
  useEffect(() => {
    if (
      Class === "Play" ||
      Class === "Nursery" ||
      Class === "One" ||
      Class === "Two"
    ) {
      setXmSub(primarySub);
    } else if (Class === "Three" || Class === "Four") {
      setXmSub(secondarySub);
    } else if (Class === "Five") {
      setXmSub(classFiveSub);
    } else if (Class === "Six" || Class === "Seven") {
      setXmSub(jscSub);
    } else if (Class === "Eight") {
      setXmSub(jscSub);
    } else if (Class === "Ten" || Class === "Nine") {
      setXmSub([...sscSub]);
    }
  }, [Class]);


  function groupBy(objectArray, property) {
    return objectArray?.reduce((acc, obj) => {
      const key = obj[property];
      const curGroup = acc[key] ?? [];

      return { ...acc, [key]: [...curGroup, obj] };
    }, {});
  }

  const classXm = MyXm?.Results?.filter((i) => i?.class === Class);
  const GenderXm = classXm?.filter((x) => {
    const stXmUser = dataUser?.find((i) => i?.phoneNumber === x?.studentPh);
    if (stXmUser) {
      return x;
    }
  });

  const groupedPeople = groupBy(GenderXm, "studentPh");
  const Totalresults = [];
  const GpaResults = [];

  for (const property in groupedPeople) {
    let results = 0;
    let resultsGpa = [];
    let studentPh;

    groupedPeople[property]?.map((i) => {
      const sub = i?.subResult;
      sub?.map((x) => {
        const writing = x?.writing ? x?.writing : 0;
        const mcq = x?.mcq ? x?.mcq : 0;
        const pecticNun = x?.pecticNun ? x?.pecticNun : 0;
        const result = parseInt(writing) + parseInt(pecticNun) + parseInt(mcq);

        results += result;
        resultsGpa.push({ mark: result, subMa: x });
      });
      studentPh = i?.studentPh;
    });

    const result = {
      results,
      studentPh,
    };
    const GParesult = {
      resultsGpa,
      studentPh,
    };

    Totalresults.push(result);
    GpaResults.push(GParesult);
  }

  const Gpa = (ph) => {
    const gpaFind = GpaResults.find((i) => i.studentPh === ph);
    return gpaFind;
  };

  // console.log(Totalresults, "hello");
  function calculateGPA(marks) {
    const gradePoints = marks?.map((x) => {
      const crnSub = xmSub?.find((i) => i?.name === x?.subMa?.subject);
      if (crnSub?.name === "Higher Math" || crnSub?.name === "Agricultural") {
        const optionalSub =
          x?.mark >= 80
            ? 3
            : x?.mark >= 70
            ? 2
            : x?.mark >= 60
            ? 1.5
            : x?.mark >= 50
            ? 1
            : 0;
        return optionalSub;
      } else if (x?.mark >= Math.ceil((crnSub?.maxNum / 100) * 80)) {
        return 5;
      } else if (x?.mark >= Math.ceil((crnSub?.maxNum / 100) * 70)) {
        return 4;
      } else if (x?.mark >= Math.ceil((crnSub?.maxNum / 100) * 60)) {
        return 3.5;
      } else if (x?.mark >= Math.ceil((crnSub?.maxNum / 100) * 50)) {
        return 3;
      } else if (x?.mark >= Math.ceil((crnSub?.maxNum / 100) * 40)) {
        return 2;
      } else if (x?.mark >= Math.ceil((crnSub?.maxNum / 100) * 33)) {
        return 1;
      } else {
        return 0;
      }
    });

    const great = (gpa) => {
      if (gpa >= 5) {
        return "A+";
      } else if (gpa >= 4) {
        return "A";
      } else if (gpa >= 3.5) {
        return "A-";
      } else if (gpa >= 3) {
        return "B";
      } else if (gpa >= 2) {
        return "C";
      } else if (gpa >= 1) {
        return "D";
      } else {
        return "F";
      }
    };

    const totalGradePoints = gradePoints?.reduce((acc, curr) => acc + curr, 0);
    const subLength =
      Class === "Ten" || Class === "Nine" ? xmSub?.length - 2 : xmSub?.length;
    const gpa = totalGradePoints / subLength;

    return [  gpa > 5 ? Math.floor(gpa).toFixed(2) : gpa.toFixed(2), great(gpa)];
  }

  const findMyXm = (phone) => {
    const myResult = MyXm?.Results?.find((i) => i?.studentPh === phone);
    return myResult;
  };



  useEffect(() => {
    fetch(
      "https://bulksmsbd.net/api/getBalanceApi?api_key=I6dXEMHybK6zQZzr2UJd"
    )
      .then((response) => response.json())
      .then((data) => {
        setSmsBalance(data);
      })
      .catch((error) => console.error(error));
  }, []);

  useEffect(() => {
    setData(users);
  }, [users]);

  if (userLoading) {
    return <Loading />;
  }

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
  };

  const filteredUsers = dataUser?.filter((user) =>
    user.firstName.toLowerCase().startsWith(searchTerm.toLowerCase())
  );
  const students = users?.filter((i) => i?.role?.includes("student"));

  const handleClass = (classData) => {
    setClass(classData);
    if (classData === "All") {
      return setData(users);
    } else if (
      classData === "teacher" ||
      classData === "garden" ||
      classData === "student"
    ) {
      const data = users?.filter((i) => i?.role?.includes(classData));
      return setData(data);
    } else {
      const studentValue = students?.filter((i) =>
        i?.class?.includes(classData)
      );
      const sorted = studentValue?.sort(function (a, b) {
        return a.roleNo - b.roleNo;
      });
      setData(sorted);
    }
  };

  const userNumbers = () => {
    const numbers = [];
    filteredUsers?.map((i) => {
      const number = i?.phoneNumber2
        ? i?.phoneNumber2?.slice(1)
        : i?.phoneNumber?.slice(1);
      numbers.push(number);
    });
    const numberString = numbers.join(", ");
    return numberString;
  };

  // many sms message ===========++++
  const manySMS = [];
  const userNm = (Phone) => {
    const user = users?.find((i) => i?.phoneNumber?.includes(Phone));
    return user;
  };
  const userResult = (Phone) => {
    const result = MyXm?.Results?.find((i) => i?.studentPh?.includes(Phone));
    return result;
  };

  filteredUsers?.map((i) => {
    
    const sms = {
      to: i?.phoneNumber2
        ? i?.phoneNumber2?.slice(1)
        : i?.phoneNumber?.slice(1),
      message: `${userNm(i?.phoneNumber)?.firstName} ${
        userNm(i?.phoneNumber)?.lastName
      }, Your 2nd Semester result: ${totalMarks(
        userResult(i?.phoneNumber)
      ) || "00"}/${totalMaxMarks(
        Class
      )}, GPA: ${calculateGreat(findMyXm(i?.phoneNumber), xmSub)?.status ==="FAIL" ? "0.00": calculateGPA(Gpa(i?.phoneNumber)?.resultsGpa)[0]}, Grade: ${calculateGreat(findMyXm(i?.phoneNumber), xmSub)?.status ==="FAIL" ? "F": calculateGPA(Gpa(i?.phoneNumber)?.resultsGpa)[1]}. - nabojagoron-academy.com`,
    };
    manySMS.push(sms);
  });

  // send Single Sms Configure +++++++
  const API_URL2 = "https://bulksmsbd.net/api/smsapimany";
  const API_URL1 = "https://bulksmsbd.net/api/smsapi";
  const apiKey = "I6dXEMHybK6zQZzr2UJd";
  const SENDER_ID = "8809617611038";
  const RECIPIENT_NUMBERS = userNumbers();


  const handaleSendSms = () => {
    setLoading(true);
    setError("");

    const data1 = {
      api_key: apiKey,
      senderid: SENDER_ID,
      number: RECIPIENT_NUMBERS,
      message: message,
    };

    const data2 = {
      api_key: apiKey,
      senderid: SENDER_ID,
      messages: manySMS,
    };

    const url = smsType === "Single" ? API_URL1 : API_URL2;
    const data = smsType === "Single" ? data1 : data2;

    axios
      .post(url, data)
      .then((response) => {
        if (response.data.response_code === 202) {
          toast.success("SMS sent successfully!");
          setError("");
          setSend("");
        } else {
          toast.error(response.data.error_message);
          setError(response.data.error_message);
        }
        console.log(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Failed to send SMS:", error);
        toast.error("some this is worng");
        setLoading(false);
      });
  };





  return (
    <div className="p-2 sm:p-0">
      <div className="w-full">
        <div className="text-center w-full flex items-center gap-3 justify-between p-3 py-4 shadow-md sm:mb-5 mb-3 rounded-md bg-white">
          <div className="">
            <input
              type="search"
              value={searchTerm}
              onChange={handleSearch}
              className="border rounded-3xl w-[150px] sm:w-auto ring-[#b06fff]-focus ring-[#eddeff] border-[#eddeff] ring-2 outline-0 p-1 px-3"
              placeholder="Search User"
              name=""
              id=""
            />
          </div>
          <div
            className={`flex bg-[#f3f9fb] max-w-[500px] border border-[#eddeff] rounded-3xl w-full`}
          >
            <div className="w-[100px] bg-[#eddeff] flex items-center justify-center rounded-r-none rounded-3xl">
              <span className="text-xl font-Oswald font-bold text-purple-700">
                {dataUser?.length}
              </span>
            </div>
            <select
              onChange={(e) => handleClass(e.target.value)}
              className="text-sm border px-3 py-1.5 rounded-l-none rounded-3xl w-full"
            >
              <option value="All" select>
                All
              </option>
              <option value="teacher">Teacher</option>
              <option value="student">Student</option>
              <option value="garden">Garden</option>
              <option value="Play">Play</option>
              <option value="Nursery">Nursery</option>
              <option value="One">One</option>
              <option value="Two">Two</option>
              <option value="Three">Three</option>
              <option value="Four">Four</option>
              <option value="Five">Five</option>
              <option value="Six">Six</option>
              <option value="Seven">Seven</option>
              <option value="Eight">Eight</option>
              <option value="Nine">Nine</option>
              <option value="Ten">Ten</option>
            </select>
          </div>
        </div>

        <div className="w-full p-3 shadow-md mb-3 rounded-md bg-white">
          <div className="w-full flex items-center gap-3 justify-between">
            <div className="flex gap-x-2 items-center">
              <p className="text-[14px]">SMS Balance</p>
              <p className="font-Oswald text-[16px] bg-purple-100 rounded-md px-1 text-purple-700">
                {smsBalance?.balance}
              </p>
            </div>
            <div className="flex gap-x-2 text-[12px] sm:text-[14px] font-bold justify-end duration-800 items-center">
              <p
                onClick={() => setSmsType("Single")}
                className={`${
                  smsType === "Single"
                    ? "bg-purple-700 text-white"
                    : "bg-purple-100 text-purple-700"
                } duration-500 cursor-pointer rounded-md px-2 py-1`}
              >
                Single SMS
              </p>
              <p
                onClick={() => setSmsType("Many")}
                className={`${
                  smsType === "Many"
                    ? "bg-purple-700 text-white"
                    : "bg-purple-100 text-purple-700"
                } duration-500 cursor-pointer rounded-md px-2 py-1`}
              >
                Many SMS
              </p>
            </div>
          </div>
          {smsType === "Many" && (
            <div className="mt-3 text-[12px]">
              <p>{manySMS[0]?.message}</p>
            </div>
          )}
        </div>

        <div className="mt-4 w-full bg-white rounded-2xl sm:pt-3  sm:p-6 p-3">
          <div className="flex py-2 items-center justify-between">
            <h1 className="text-2xl font-bold font-Oswald text-purple-700">
              Receiver {filteredUsers?.length} {Class}
            </h1>
            <div className="">
              <input
                type="text"
                value={send}
                placeholder="Type Send"
                onChange={(e) => setSend(e.target.value)}
                className="input input-sm input-bordered mx-auto w-[100px]"
              />
            </div>
          </div>
          <div className="max-h-[330px] overflow-y-scroll">
            <div className="max-h-[300px] px-2 smsUser-grid gap-y-2 text-justify my-5 rounded-md">
              {filteredUsers?.map((i, index) => (
                <div
                  key={index}
                  className="w-6 h-6 grid place-content-center overflow-hidden rounded-full bg-[#7e16a0] ring ring-[#d583f5] ring-offset-base-100 ring-offset-1"
                >
                  {!i?.imageURL && (
                    <h2 className="text-white text-[14px] element-font-5 font-bold">
                      {i?.firstName?.slice(0, 1)}
                      {i?.lastName?.slice(0, 1)}
                    </h2>
                  )}
                  {i?.imageURL && (
                    <img
                      src={i?.imageURL}
                      className="w-full rounded-full"
                      alt="pic"
                    />
                  )}
                </div>
              ))}
            </div>
          </div>
          <div className="my-4 relative">
            <textarea
              name="Message"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              className="textarea w-full h-[110px] textarea-bordered"
              placeholder="Enter Your Message"
            ></textarea>
            <p className="absolute -top-1 -right-1 text-[12px] text-purple-700 bg-purple-100 px-1 rounded-md">
              {message.length}
            </p>
          </div>
          {loading && (
            <div className="w-full flex items-center justify-center">
              <ProgressBar
                height="80"
                width="80"
                ariaLabel="progress-bar-loading"
                wrapperStyle={{}}
                wrapperClass="progress-bar-wrapper"
                borderColor="#F4442E"
                barColor="#51E5FF"
              />
            </div>
          )}

          <div>
            <p className="text-sm text-accent mb-2 text-center">{error}</p>
            <button
              onClick={handaleSendSms}
              className="btn w-full font-bold text-xl btn-primary text-white"
              disabled={send !== "Send"}
            >
              send Sms
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BulkSms;
